/**
 * Motive, erzeugt mit `/melody-math`.
 *
 * Alle in phrygisch — die kleine Sekunde ueber dem Grundton ist das Intervall,
 * das seit Jahrhunderten fuer Bedrohung steht. Die Folgen selbst stammen aus
 * mathematischen Reihen, nicht aus dem Gefuehl: Das haelt sie unperiodisch,
 * sodass sie sich auch nach dem zwanzigsten Durchgang nicht abnutzen.
 */

export type Motif = readonly (readonly [string, number])[];

/**
 * Station: goldener Schnitt ueber D-phrygisch.
 * `⌊i·φ⌋ mod 7` teilt die Skala nie gleichmaessig — die Linie wandert, ohne je
 * in eine Schleife zu fallen.
 *
 * /melody-math --scale phrygian --root D --len 16 --algo golden --octave 3
 */
export const BASE_MOTIF: Motif = [
  ['D3', 2.0], ['Eb3', 3.0], ['G3', 2.0], ['A3', 4.0],
  ['C4', 2.0], ['Eb3', 3.0], ['F3', 2.0], ['A3', 4.0],
  ['Bb3', 2.0], ['D3', 3.0], ['F3', 2.0], ['G3', 4.0],
];

/**
 * Weltkarte: Zufallsschritt mit Gravitation zur Tonika.
 * Bleibt fast durchgehend auf dem Grundton und kriecht erst spaet nach Eb
 * hinauf — die Bewegung, die man bei einer langen Ueberfahrt haben will:
 * beinahe keine, und dann doch.
 *
 * /melody-math --scale phrygian --root D --len 12 --algo walk --octave 3 --seed 23
 */
export const VOYAGE_MOTIF: Motif = [
  ['D3', 3.0], ['D3', 2.0], ['D3', 4.0], ['D3', 2.5],
  ['D3', 5.0], ['D3', 3.0], ['Eb3', 2.0], ['D3', 4.0],
  ['Eb3', 2.5], ['Eb3', 5.0], ['F3', 3.0], ['Bb3', 2.0],
];

/**
 * Einsatzort: Collatz-Folge modulo Skalenlaenge — deterministisches Chaos.
 * Kurz, sprunghaft, ohne erkennbares Zentrum. Passt zu einem Ort, an dem
 * etwas passiert ist, das niemand einordnen kann.
 *
 * /melody-math --scale phrygian --root A --len 7 --algo collatz --octave 3 --seed 7
 */
export const SITE_MOTIF: Motif = [
  ['G4', 1.0], ['A3', 0.7], ['D4', 1.4], ['F4', 1.0],
  ['C4', 0.7], ['C4', 1.4], ['E4', 1.0],
];

/** Grundton der Flaeche je Szene. */
export const DRONE_ROOT = {
  menu: 'D2',
  base: 'D2',
  voyage: 'D2',
  site: 'A1',
  finale: 'D2',
} as const;
